import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { isEmpty } from 'mojito/utils';
import SelectionButton from 'modules/selection-button/index.js';
import BetslipModuleUtils from 'modules/betslip/utils.js';

const { FlexPane, Text, Image } = MojitoPresentation.Components;
const { utils: EventUtils } = MojitoServices.SportsContent.Events;

const PriceBoostItem = props => {
    const {
        event,
        market,
        selection,
        mojitoTools: { config, l10n, stringResolver, appContext },
    } = props;
    const { oddsFormat } = appContext.userSettings();
    const selectionPart = { selectionName: selection.name, hcap: selection.handicapLabel };
    const marketNameDisplay = BetslipModuleUtils.resolveNameAndHandicapLabel(selectionPart, l10n);
    const hasMarketName = !isEmpty(market.name);
    return (
        <FlexPane class="ta-PriceBoostItem" config={config.container}>
            <FlexPane class="ta-labelContainer" config={config.labelContainer}>
                <Text config={config.selectionLabel}>{marketNameDisplay}</Text>
                {config.showMarketLabel && hasMarketName && (
                    <Text config={config.marketLabel}>{market.name}</Text>
                )}
            </FlexPane>
            <FlexPane
                class="ta-priceInformationContainer"
                config={config.priceInformationContainer}
            >
                <FlexPane config={config.wasContainer}>
                    <Text config={config.wasTitle}>
                        {stringResolver.resolveString('$PRICE_BOOST_ITEM.WAS')}
                    </Text>
                    <Text config={config.wasPrice}>
                        {EventUtils.getOdds(selection.basePrice, oddsFormat, l10n)}
                    </Text>
                </FlexPane>
                <Image config={config.indicationIcon} />
                <SelectionButton
                    selection={selection}
                    event={event}
                    marketStatus={market.status}
                    marketType={market.type}
                    config={config.selectionButton}
                    marketId={market.id}
                />
            </FlexPane>
        </FlexPane>
    );
};

export default PriceBoostItem;
